/** @format */

import React from "react";
import Twitter from "../../assets/Twitter.svg";
// import Facebook from "../../assets/Facebook.svg";
import Instagram from "../../assets/Instagram.svg";

const SocialMedia = () => {
  return (
    <div className="text-center py-16">
      <div className="flex space-x-8 justify-center items-center">
        <a
          href="https://twitter.com/Fit_Stats"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Twitter} alt="Twitter" className="cursor-pointer" />
        </a>
        <a
          href="https://instagram.com/fit_stats"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Instagram} alt="Instagram" className="cursor-pointer" />
        </a>
        {/* <img src={Facebook} alt="Facebook" className="cursor-pointer" /> */}
      </div>
    </div>
  );
};

export default SocialMedia;
